import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from '../../../../config/config';
const HelpLinkService = {
    async GetHelpSite(redirectCallback) {
        try {

            const token = localStorage.getItem('token');
            if (!token || token == "null") {

                redirectCallback();
                return; // Return early to prevent further execution
            }
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/SuperAdmin/GetHelpSite`);

            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetForms(redirectCallback) {
        try {

            const token = localStorage.getItem('token');
            if (!token || token == "null") {

                redirectCallback();
                return; // Return early to prevent further execution
            }
            const ClientID = localStorage.getItem('CompanyID');

            const response = await axiosInstance.get(`/SuperAdmin/GetForms`);

            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetSubFormByFormID(redirectCallback, FormID) {
        try {

            const token = localStorage.getItem('token');
            if (!token || token == "null") {

                redirectCallback();
                return; // Return early to prevent further execution
            }
            const ClientID = localStorage.getItem('CompanyID');

            const response = await axiosInstance.get(`/SuperAdmin/GetSubFormByFormID?FormID=${FormID}`);

            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GenerateHelpLink(FormID, FormName) {
        try {

            const token = localStorage.getItem('token');
            const ClientID = localStorage.getItem('CompanyID');

            const response = await axiosInstance.get(`/SuperAdmin/GenerateHelpLink?FormID=${FormID}&FormName=${FormName}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteHelpLink(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SuperAdmin/DeleteHelpSite?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default HelpLinkService;